export default "__VITE_ASSET__CiZlLbyY__"